@if (products.length) { @if (seeProducts) {
<div class="dropcart__products-list">
  @if (products.length) {
  <div class="row m-0" class="mensaje-entrega mb-3">
    <div class="header">
      <i class="fas fa-check-circle" style="margin-right: 10px"></i>
      <span class="fw-bold"> Productos Disponible </span>
    </div>
    <app-products-list-summary-cart [products]="products">
    </app-products-list-summary-cart>
  </div>
  } @if (shippingNotSupported.length) {
  <div class="row m-0" class="conflicto-entrega mb-3">
    <div class="header">
      <i class="fas fa-check-circle" style="margin-right: 10px"></i>
      <span class="fw-bold"> Productos Sin stock </span>
    </div>
    <app-products-list-summary-cart [products]="shippingNotSupported">
    </app-products-list-summary-cart>
  </div>
  }
</div>
} @if (seePrices) {
<div class="dropcart__totals" [ngClass]="{ 'border-0': seeProducts == false }">
  <table>
    @if (show) {
    <tr>
      <th>Subtotal</th>
      <td>{{ total.subtotal | currency }}</td>
    </tr>
    <tr>
      <th>{{ taxConfig.name }}</th>
      <td>{{ total.iva | currency }}</td>
    </tr>
    <tr>
      <th>Entrega</th>
      <td>{{ total.shipment | currency }}</td>
    </tr>
    <tr>
      <th>Total</th>
      <td class="fw-bold">{{ total.total | currency }}</td>
    </tr>
    }
  </table>
</div>
} }
